import base64url from 'base64url';
import base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
/**
 * Provides hash for a given string.
 *
 * @param value - string to hash
 * @returns - hash for a given string.
 */
export const getHash = (value: string): string => {
  const input: string = JSON.stringify(value);
  const sha256Encoded = sha256(input);
  const base64Encoded = base64.stringify(sha256Encoded).toString();
  return base64url.fromBase64(base64Encoded);
};
